<eon-ui-color-separator />
<div class="login-page">
    <div class="eon-logo-wrapper">
        <eon-ui-image slot="logo"
            src="https://www.eon.com/content/dam/eon/eon-com/eon-com-assets/content/general/logo/logo-eon-red.svg"
            alt="E.ON Logo" />
    </div>
    @if( width > 1024) {
    <div class="demo-image-wrapper">
        <img src="assets/aem-login.png" alt="IQ-Energy-Login">
    </div>
    }
    <div class="right-side">
        <div class="content-container">
            <div class="heading">
                <eon-ui-headline text="{{'login.login' | translate}}" size="h2" />
            </div>
            <p class="description">
                {{ 'login.loginText' | translate }}
            </p>
            <div class="login-button-containers">
                <div class="login-button-container">
                    <eon-ui-button text="{{'login.loginAuth0' | translate}}" size="larg" fullWidth
                        (click)="login('authZero')" (keydown.enter)="login('authZero')"
                        (keydown.space)="login('authZero')" />
                </div>
            </div>
        </div>
        <app-legal-links [iconPosition]="'left'" class="login-page-links" />
    </div>
</div>